import { Injectable } from '@angular/core';
import { SidebarLink } from 'src/app/core/interfaces/sidebar';
import { UsersService } from 'src/app/data/services/users.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  public showSidebar: boolean = false;

  private _showSidebar$ = new BehaviorSubject<boolean>(false);
  showSidebar$ = this._showSidebar$.asObservable();

  constructor(
    private userService: UsersService
  ) { }
  
  getSidebarLinks(): SidebarLink[] {
    let currentUserGroup;
    this.userService.getGroup$().subscribe(group => {
      currentUserGroup = group;
    });
    switch (currentUserGroup) {
      case 'ADMINISTRATOR':
        return [
          { label: 'Mis lecciones', link: '/lessons' },
          { label: 'Usuarios', link: '/users', icon: 'fa-regular fa-user' },
          //{ label: 'Métricas', link: '/metrics/lesson/list', icon: 'bx-bar-chart-alt-2' },
          { label: 'Valoraciones', link: '/reviews', icon: 'fa-regular fa-comment' },
        ];
      case 'MANAGER':
        return [
          { label: 'Mis lecciones', link: '/lessons' },
          { label: 'Usuarios', link: '/users', icon: 'fa-regular fa-user' },
          //{ label: 'Métricas', link: '/metrics/lesson/list', icon: 'bx-bar-chart-alt-2' },
          { label: 'Valoraciones', link: '/reviews', icon: 'fa-regular fa-comment' },
        ];
      /*case 'STUDENT':
        return [];*/
      case 'TEACHER':
        return [
          { label: 'Mis lecciones', link: '/lessons' },
          //{ label: 'Métricas', link: '/metrics/lesson/list', icon: 'bx-bar-chart-alt-2' },
        ];
      case 'SUPER':
        return [
          { label: 'Dashboard', link: '/dashboard', icon: 'fa fa-chart-line' },
          { label: 'Programas', link: '/programs' },
          { label: 'Imágenes', link: '/images', icon: 'bx-disc' },
          { label: 'Fleets', link: '/fleets', icon: 'fa fa-network-wired' },
          { label: 'Lecciones', link: '/lessons', icon: 'bx-book-content' },
          { label: 'Valoraciones', link: '/reviews', icon: 'fa-regular fa-comment' },
          { label: 'Usuarios', link: '/users', icon: 'fa-regular fa-user' },
          { label: 'Logs', link: '/logs', icon: 'fa-solid fa-bug' },
          { label: 'Actividad', link: '/user-activity', icon: 'bx-history' }
        ];
      default:
        return [];
    }
  }

  open() {
    this.showSidebar = true;
  }
  close() {
    this.showSidebar = false;
  }

  setShowSidebar(value: boolean) {
    this.showSidebar = value;
    this._showSidebar$.next(value);
  }
}